import { createStore as _createStore } from 'vuex';
import VuexPersist from 'vuex-persist';

import common from '@/store/modules/common/store';
import immocheckValuation from '@/store/modules/immocheckValuation/store';
import { splitStoreModule } from '@/store/modules/split/store';

import { isServer } from '@/helpers/Platform/Platform';
import { AppState, FunnelStorageKey } from './types';

export const createStore = () => {
  const store = _createStore({
    modules: {
      common,
      immocheckValuation,
      split: splitStoreModule,
    },
  });

  // Don't set in SSR mode - window.localStorage is not available in SSR
  if (!isServer()) {
    new VuexPersist<AppState>({
      key: FunnelStorageKey,
      storage: window.localStorage,
      reducer: (state) => ({
        immocheckValuation: { ...state.immocheckValuation, loading: false },
      }),
    }).plugin(store);
  }

  return store;
};
